import type { HouseholdIncomeFormData } from './types';

export const initialValues: HouseholdIncomeFormData = {
  homeownerInformation: {
    name: '',
    phone: '',
    email: '',
    currentAddress: '',
    propertyAddress: '',
    purchasePrice: '',
    gender: '',
    race: [],
    cityEmployee: '',
  },
  employmentTax: {
    w2Forms: [],
    irs1040Forms: [],
    payStubs: [],
  },
  cashAssets: {
    checkingSavingsStatements: [],
    cashAppStatements: [],
    payPalStatements: [],
    venmoStatements: [],
    zelleStatements: [],
    googlePayStatements: [],
    revolutStatements: [],
  },
  otherIncome: {
    pensionDocuments: [],
    socialSecurityDocuments: [],
    ssiDocuments: [],
    otherIncomeDocuments: [],
  },
  review: {},
};

export const genderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'other' },
  { label: 'Prefer not to say', value: 'prefer-not-to-say' },
];

export const raceOptions = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Hispanic or Latino',
  'Other',
];

export const cityEmployeeOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
